import { z } from "zod";

/** Team alert recipients for every "request access through my employer" entry. One list, one place. */
export const EMPLOYER_ACCESS_RECIPIENTS: readonly string[] = [
  "josh@homeapproach.com",
  "tovah@homeapproach.com",
  "partnerships@homeapproach.com",
];

export const EMPLOYER_ACCESS_CONSENT_VERSION = "2026-10-employer-access-v1";

const opt = (max: number) => z.string().trim().max(max).optional().or(z.literal(""));

export const employerAccessSchema = z.object({
  firstName: z.string().trim().min(1).max(60),
  lastName: z.string().trim().min(1).max(60),
  email: z.string().trim().email().max(255),
  phone: z.string().trim().regex(/^\(\d{3}\) \d{3}-\d{4}$/).optional().or(z.literal("")),
  employerName: z.string().trim().min(2).max(150),
  hrContactName: opt(120),
  hrContactEmail: z.string().trim().email().max(255).optional().or(z.literal("")),
  mayNameMember: z.boolean().default(false),
  source: z.string().trim().max(60).regex(/^[a-z0-9_-]*$/).optional().or(z.literal("")),
  sourcePath: opt(300),
});

export type EmployerAccessInput = z.infer<typeof employerAccessSchema>;

/**
 * Employer-only access rule: new accounts are created only through an employer
 * sponsor page (signup carries an employer name), or for LifeMart members
 * (treated as an employer sponsor). Everyone else joins the waitlist.
 */
export function canCreateAccount(opts: { employer?: string | null; lifeMartVerified?: boolean; orgCodeVerified?: boolean }): boolean {
  if (opts.lifeMartVerified || opts.orgCodeVerified) return true;
  return !!opts.employer && opts.employer.trim().length >= 2;
}
